export const handleDownload = (data: string | URL | undefined, fileName?: string) => {
  if (data) {
    const a = document.createElement('a');
    if (typeof data === 'string') {
      a.href = data;
    }
    a.download = fileName || 'Profit & Loss';
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
};

export const printIframe = (id: string): boolean => {
  const documentWithFrames = document as Document & { frames?: any };

  const iframe = documentWithFrames.frames
    ? (documentWithFrames.frames[id] as HTMLIFrameElement)
    : (document.getElementById(id) as HTMLIFrameElement);

  const iframeWindow = iframe.contentWindow || iframe;

  iframe.focus();
  (iframeWindow as Window).print();

  return false;
};

export const getFlagEmoji = (countryCode: string): string => {
  const codePoints = countryCode
    .toUpperCase() // Ensure the country code is in uppercase
    .split('')
    .map(char => 127397 + char.charCodeAt(0)); // Convert each letter to a regional indicator

  return String.fromCodePoint(...codePoints); // Create the emoji from the code points
};

export const removeSpacesFromString = (str: string) => str.replace(/\s/g, '');

export const removeWhiteSpacesFromString = (str: string) => str.replace(/\s+/g, ' ').trimStart();

export const removeSpacesOnBlur = (str: string) => str.trimEnd();
